import { useState } from 'react'
import convertToBase64 from '../helpers/convertToBase64'
import trimBase64Text from '../helpers/trimBase64Text'

/**
 * Extension from the file NAME, lowercased, or '' when there is none.
 *
 * Not from the MIME type: files with no registered type (our own .tmpl, for
 * one) report `file.type === ''`, which made the old `type.split('/')[1]`
 * come out undefined.
 */
export const fileExtension = (name = '') => {
    const dot = name.lastIndexOf('.')
    return dot > 0 && dot < name.length - 1
        ? name.slice(dot + 1).toLowerCase()
        : ''
}

/** One file as an attachment the API stores: its name, base64 body and extension. */
const readAttachment = async (file) => ({
    file_name: file.name,
    encoded_file: trimBase64Text(await convertToBase64(file)),
    ext: fileExtension(file.name),
})

/**
 * Reads every file chosen in an <input type="file" multiple> into base64.
 *
 * `handleFileRead` resolves to the files read, in the order chosen (and
 * keeps them as `files`); an email takes any number of attachments of any
 * type, as the old app did. Cancelling the picker fires `change` with an
 * empty file list; that resolves to [] instead of a crash on `file.name`.
 * The input is cleared afterwards, so choosing the same file again still
 * fires `change`.
 */
const useFileHandler = () => {
    const [files, setFiles] = useState([])

    const handleFileRead = async (event) => {
        const chosen = Array.from(event?.target?.files ?? [])
        if (event?.target) event.target.value = ''
        if (!chosen.length) return []
        const read = await Promise.all(chosen.map(readAttachment))
        setFiles(read)
        return read
    }

    return { handleFileRead, files }
}

export default useFileHandler
